import { AccordionItem, Text, List, Stack, Heading } from 'braid-design-system';
export const SectionB = () => (
  <AccordionItem id="section-b" label="Section B: Job Posting">
    <Stack space="gutter">
      <Heading level="4">Functional</Heading>
      <List type="number" start={72}>
        <Text>
          Section B applies if you have chosen to use the job posting
          functionality through the SEEK API and we reserve the right to request
          that you change or rectify any job posting functionality at any time.
        </Text>
        <Stack space="medium">
          <Text>
            You must ensure that the following job posting functionality is
            enabled for Advertisers via the SEEK API at all times:
          </Text>
          <List type="alpha">
            <Text>
              the ability for an Advertiser to create, update and expire an ad;
            </Text>
            <Text>
              the ability for the Advertiser to use multiple Advertiser accounts
              with us;
            </Text>
            <Text>
              enable and display all SEEK Group ad products via the Ad Selection
              Panel or Ad Selection with GraphQL feature;
            </Text>
            <Text>
              the ability for an Advertiser to specify the location of a
              position supported by the SEEK APAC hierarchy when posting a job
              ad;
            </Text>
            <Text>
              the ability for an Advertiser to specify the job category of a
              position supported by the SEEK APAC hierarchy when posting a job
              ad;
            </Text>
            <Text>
              the ability for an Advertiser to select SEEK Group approved
              branding when posting a job ad;
            </Text>
            <Text>
              the ability for an Advertiser to specify the right salary
              frequency and choose the right currency from the list of our
              supported currencies when specifying salary information;
            </Text>
            <Text>
              distribute the live link of the posted job ad to the Advertiser;
            </Text>
            <Text>
              display appropriate messaging to the Advertiser if an error occurs
              when posting a job; and
            </Text>
            <Text>
              the ability for an Advertiser to post an ad on our websites and
              apps for 30 days.
            </Text>
          </List>
        </Stack>
      </List>
    </Stack>
  </AccordionItem>
);
